import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=6074b6ba&"
import script from "./Tracking.vue?vue&type=script&lang=ts&"
export * from "./Tracking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports